// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gz-a";
export var fulfillmentFormRail = "_gz-9";
export var headerTitleRow = "_gz-c";
export var orderDetailsWrapper = "_gz-7";
export var orderLinkTrigger = "_gz-2";
export var paymentInformationGrid = "_gz-h";
export var paymentSummaryColumn = "_gz-i";
export var shipmentContainer = "_gz-b";
export var shipmentDetailsMainPane = "_gz-8";
export var shipmentNavigationCard = "_gz-5";
export var shipmentNavigationRail = "_gz-3";
export var shipmentNavigationRailHeader = "_gz-4";
export var shipmentSummaryFact = "_gz-e";
export var shipmentSummaryGrid = "_gz-d";
export var shipmentSummaryMetadataRow = "_gz-f";
export var shipmentSummaryTags = "_gz-g";
export var shipmentWorkspace = "_gz-0";
export var shipmentWorkspaceContent = "_gz-6";
export var shipmentWorkspaceHeader = "_gz-1";